<div class="row" style="width:100%; float: right; text-align: right; margin-top: 0px; padding-top: 0px; margin-right:0px !important"><div class="col-11"></div><div class="col-1 text-right" style="float:right; margin-right:0px; padding-right:0px;"><mat-icon style="float:right; cursor: pointer;" (click) = "onNoClick()">cancel</mat-icon></div></div>
<h1 mat-dialog-title>{{labels.lblAddNewTest}}</h1>
<div mat-dialog-content>
  <form (ngSubmit)="onSubmit()" #insertForm="ngForm">
    <div fxLayout="column">
      <mat-form-field  appearance="none" fxFlex="60%">
        <mat-label>{{labels.lblType}}</mat-label>
        <mat-select ngModel name='type' #type="ngModel" required>
          <mat-option (click) = "onSelect(1)" value="1">{{labels.lblTest}}</mat-option>
          <mat-option (click) = "onSelect(2)" value="2">{{labels.lblPretest}}</mat-option>
          <mat-option (click) = "onSelect(3)" value="3">{{labels.lblSurvey}}</mat-option>
        </mat-select>
        <mat-error style="margin-bottom:1.5vh !important;">{{labels.lblfieldRequired}}</mat-error>
      </mat-form-field>
      @if (showFields == true) {
        <mat-form-field appearance="none" fxFlex="60%">
          @if (testType == 1) {
            <mat-label>{{labels.lblTestName}}</mat-label>
          }
          @if (testType == 2) {
            <mat-label>{{labels.lblPretestName}}</mat-label>
          }
          @if (testType == 3) {
            <mat-label>{{labels.lblSurveyName}}</mat-label>
          }
          <input matInput ngModel name="name" #name="ngModel" required>
          <mat-error style="margin-bottom:1.5vh !important;">{{labels.lblfieldRequired}}</mat-error>
        </mat-form-field>
      }
      @if (showFields == true && testType == 1) {
        <mat-form-field appearance="none" fxFlex="60%">
          <mat-label>{{labels.lblMinPercentage}}</mat-label>
          <input matInput number ngModel name="minPercentage" #minPercentage="ngModel" required>
          <mat-error style="margin-bottom:1.5vh !important;">{{labels.lblfieldRequired}}</mat-error>
        </mat-form-field>
      }
      @if (showFields == true && testType == 1) {
        <mat-checkbox
          ngModel
          name="duration-time"
          [checked]="true"
          class="example-margin checkbox"
          (change)="showDurationTime($event)"
          >
          {{labels.lblTestDuration}}
        </mat-checkbox >
      }
      @if (showFields == true && testType == 1 && showDurTime == true) {
        <mat-form-field appearance="none" fxFlex="60%">
          <mat-label>{{labels.lblTestDuration}}</mat-label>
          <input matInput number ngModel name="durationTime" #durationTime="ngModel">
        </mat-form-field>
      }

      <!-- Checkbox za Obavezan -->
      @if (showFields == true && testType == 1) {
        <mat-checkbox
          appearance="none"
          class="example-margin checkbox"
          (click)="toggleRequired()">
          <mat-label>{{labels.lblRequiredTest}}</mat-label>
        </mat-checkbox>
      }

      <!-- Input za broj pokusaja -->
      @if (showFields == true && testType == 1) {
        <mat-form-field appearance="none" fxFlex="60%">
          <mat-label>{{labels.lblNumofAttemptsTest}}</mat-label>
          <input matInput number name="attempts" [(ngModel)]="attempts" required/>
        </mat-form-field>
      }
      @if (showFields == true && testType == 1) {
        <mat-checkbox
          appearance="none"
          class="example-margin checkbox"
          (click)="toggleIsOnlyTest()">
          <mat-label>Blokiraj posle X padova?</mat-label>
        </mat-checkbox>
      }
      @if (showFields == true && testType == 1) {
        <mat-form-field appearance="none" fxFlex="60%">
          <mat-label>Posebna poruka posle X padova</mat-label>
          <input matInput name="customFailMessage" [(ngModel)]="customFailMessage" required/>
        </mat-form-field>
      }

      @if (showFields == true) {
        <mat-form-field  appearance="none" fxFlex="60%">
          @if (admin.isAdmin == true) {
            <mat-label>{{labels.lblTrainer}}</mat-label>
          }
          @if (admin.isAdmin == false) {
            <h4 >{{labels.lblTrainer}}</h4>
          }
          @if (admin.isAdmin == false) {
            <input matInput ngModel={{admin.id}} name = "trainerId" hidden>
          }
          @if (admin.isAdmin == false) {
            <div>{{admin.firstName}} {{admin.lastName}}</div>
          }
          @if (admin.isAdmin == true) {
            <mat-select ngModel name='trainerId' required>
              @for (t of trainers; track t) {
                <mat-option [value] = "t.id">{{t.firstName}} {{t.lastName}}</mat-option>
              }
            </mat-select>
          }
          <mat-error style="margin-bottom:1.5vh !important;">{{labels.lblfieldRequired}}</mat-error>
        </mat-form-field>
      }
      <div>
        <!-- <button class="noBtn" mat-button (click)="onNoClick()" type="button">{{labels.lblNo}}</button> -->
        <button class="btn" cdkFocusInitial style="float: right" type="submit">{{labels.lblAdd}}</button>
      </div>
    </div>
  </form>
</div>